<template>
  <ol class="steps steps-counter steps-green" :class="{ 'steps--no-labels': counterOnly }">
    <li
      v-for="(tab, i) in tabs"
      :key="tab.to"
      class="step-item"
      :class="{ completed: i < currentIndex, active: i === currentIndex }"
      :title="tab.name"
      tabindex="0"
      @click="go(tab.to)"
    >
      <!-- 진행선: 마지막 아이템은 선 없음 -->
      <span v-if="i < tabs.length - 1" class="step-line">
        <span class="step-line__fill" :style="{ width: i < currentIndex ? '100%' : '0%' }"></span>
      </span>

      <router-link class="step-link" :to="tab.to">{{ tab.name }}</router-link>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'StepsNav',
  props: { counterOnly: { type: Boolean, default: false } }, // 텍스트 보이게 기본 false
  data() {
    return {
      tabs: [
        { name: "재료입고",  to: "/eventCreate/prc1" },
        { name: "조립",      to: "/eventCreate/prc3" },
        { name: "품질검사",  to: "/eventCreate/prc4" },
        { name: "포장준비",  to: "/eventCreate/prc9" },
        { name: "제품포장",  to: "/eventCreate/prc5" },
        { name: "출고",      to: "/eventCreate/prc6" },
        { name: "운송",      to: "/eventCreate/prc7" },
        { name: "판매점입고",to: "/eventCreate/prc8" },
      ]
    };
  },
  computed: {
    currentIndex() {
      const idx = this.tabs.findIndex(t => this.$route.path.startsWith(t.to));
      return idx === -1 ? 0 : idx;
    }
  },
  methods: {
    go(path) { this.$router.push(path); }
  }
};
</script>
<style scoped>
.steps {
  display: flex;
  align-items: flex-start;      /* 선 위치 고정용 */
  list-style: none;
  margin: 0;
  padding: .75rem 1rem;
  counter-reset: step;
}

.step-item{
  --dot: 28px;         
  --line-h: 2px;       
  --gap: 3px;          
  --mask: 3px;         
  position: relative;
  flex: 1 1 0;
  text-align: center;
  min-width: 0;
  cursor: pointer;
}

/* 숫자 원 (위에 오도록 + 마스킹 링) */
.step-item::before{
  content: counter(step);
  counter-increment: step;
  display: inline-flex;
  justify-content: center; align-items: center;
  width: var(--dot); height: var(--dot);
  border-radius: 50%;
  background: #e9ecef; color: #6c757d;
  font-weight: 700; font-size: 13px;
  z-index: 3;
  box-shadow: 0 0 0 var(--mask) var(--bs-body-bg, #fff);
}

/* 진행선(회색 바) */
.step-line{
  position: absolute;
  top: calc(var(--dot)/2 - var(--line-h)/2);    
  left: calc(50% + var(--dot)/2 + var(--gap));  
  right: calc(-50% + var(--dot)/2 + var(--gap));
  height: var(--line-h);
  background: #e9ecef;
  overflow: hidden;
  z-index: 1;
}

/* 채워지는 바 */
.step-line__fill{
  position: absolute; inset: 0 auto 0 0;
  width: 0%;
  background: #2563eb;
  transition: width 360ms ease;
}

/* 현재/완료 색상(숫자 원) */
.steps-green .step-item.completed::before,
.steps-green .step-item.active::before { background:#2563eb; color:#fff; }

/* 라벨 */
.step-link{
  display:block;
  margin-top:.5rem;
  font-size:14px;               /* 크게 */
  font-weight:600;
  color: var(--bs-secondary);
  text-decoration:none;
}
.step-item.active .step-link{ font-weight:800; }  /* 선택된 텍스트 더 굵게 */
.step-item:hover .step-link{ color:#111; }
</style>
